import React, { useEffect, useState, useMemo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetLookUpDropdownListQuery } from '../../api';
import { useLanguage } from '../../contexts/LanguageContext';

const WarrantyDocumentTypeDropdown = ({ value, onChange, className, placeholder, disabled = false }) => {
    const { getCurrentLanguageId } = useLanguage();
    const [selectedDocumentType, setSelectedDocumentType] = useState(null);

    const { data: documentTypeList = [], isLoading } = useGetLookUpDropdownListQuery({
        LanguageId: getCurrentLanguageId(),
        GroupCode: 'XXBOS_WARRANTY_DOCUMENT_TYPE'
    });

    const documentTypeOptions = useMemo(() => {
        return documentTypeList.map((type) => ({
            id: type.id,
            code: type.code,
            text: type.translatedText,
            displayValue: type.translatedText
        }));
    }, [documentTypeList]);

    const handleSelectionChange = (e) => {
        setSelectedDocumentType(e.value);
        onChange(e.value ? e.value.code : '');
    };

    useEffect(() => {
        if (documentTypeOptions.length > 0 && value) {
            const found = documentTypeOptions.find((option) => parseInt(option.code) === parseInt(value));
            if (found) {
                setSelectedDocumentType(found);
            }
        } else if (!value) {
            setSelectedDocumentType(null);
        }
    }, [value, documentTypeOptions]);

    return (
        <Dropdown
            value={selectedDocumentType}
            options={documentTypeOptions}
            onChange={handleSelectionChange}
            optionLabel="displayValue"
            showClear
            className={className}
            placeholder={placeholder || 'Doküman Tipi seçiniz'}
            loading={isLoading}
            disabled={disabled}
            itemTemplate={(option) => <div>{option.text}</div>}
        />
    );
};

export default WarrantyDocumentTypeDropdown;
